module.exports = {
	"Announcement": {
		"Know More": "En savoir plus"
	},
	"Appointment": {
		"Conditions": "En cliquant sur “Valider“, vous attestez avoir pris connaissance de la politique de confidentialité et consentez au traitement de vos données personnelles par %(brand)s dans les conditions énoncées dans la présente afin de répondre à votre demande.",
		"Confirmation": "Nous avons bien pris en compte votre demande de rendez-vous en boutique avec l'un de nos conseillers, pour une aide personnalisée. Un email de confirmation vous sera renvoyé prochainement.",
		"Description": "Dior vous invite à prendre rendez-vous en boutique avec l'un de ses conseillers pour une aide personnalisée.",
		"Get an appointment": "Prendre un rendez-vous",
		"Motives": "Motifs",
		"Universes": "Univers"
	},
	"DiorMap": {
		"Search in this area": "Rechercher dans cette zone"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s Résultat",
			"other": "%(count)s Résultats",
			"zero": "%(count)s Résultat"
		},
		"Refine": "Affiner",
		"RefineAria": "Cibler la recherche à l’aide des cases à cocher ci-dessous",
		"Are you looking for?": "Vous cherchez une boutique relative aux univers Mode Femme, Homme, Baby, Joaillerie ou Horlogerie ?"
	},
	"Footer": {
		"Download the applications": "Télécharger les applications",
		"Language": "Langue",
		"Newsletter": "Ex: Christian@dior.fr",
		"Ok": "OK",
		"Subscribe to newsletter": "S'inscrire à la Newsletter"
	},
	"Form": {
		"All fields are mandatory": "Tous les champs sont obligatoires",
		"Civility": "Civilité",
		"Comments": "Commentaires",
		"Conditions": "Si vous souhaitez recevoir une confirmation par email de la part de %(brand)s cochez la case ci-dessus. Vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition au traitement des données vous concernant que vous pouvez exercer en écrivant à \"contact@dior.com\"",
		"Date": "Date souhaitée ",
		"Email": "Email",
		"Hour": "Horaire souhaitée",
		"Invalid E-mail address": "Adresse e-mail invalide",
		"Mr": "M.",
		"Mrs": "Mme",
		"Name": "Nom",
		"Phone": "Téléphone",
		"Required fields": "Champs obligatoires",
		"Submit": "Valider",
		"Surname": "Prénom"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "Boutiques Dior dans votre ville : haute couture, parfums, maroquinerie",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "Arrivée",
		"Departure": "Départ",
		"Details": "Détails",
		"Error": "Désolé nous n'avons pas pu obtenir l'itinéraire demandé, veuillez ré-essayer en modifiant l'adresse de départ et/ou le moyen de transport utilisé",
		"Follow the itinerary": "Suivre l'itinéraire",
		"Itinerary": "Itinéraire",
		"modeBICYCLING": "Consulter l’itinéraire à vélo",
		"modeDRIVING": "Consulter l’itinéraire en voiture",
		"modeTRANSIT": "Consulter l’itinéraire en transports",
		"modeWALKING": "Consulter l’itinéraire à pied",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "Veuillez utiliser votre téléphone en mode portrait"
	},
	"NavMobile": {
		"Home": "Accueil"
	},
	"Newsletter": {
		"Dior Newsletter": "Newsletter Dior",
		"Fashion and accessories": "Mode & Accessoires",
		"I wish to receive the %(newsletter)s newsletter": "Je souhaite recevoir l'actualité %(newsletter)s",
		"Newsletter Confirmation": "Vous êtes bien inscrit à la newsletter",
		"Perfume and beauty": "Parfum & Beauté",
		"Receive our newsletter": "Recevez notre newsletter",
		"Your universes": "Vos univers"
	},
	"ResultsBlock": {
		"Dior boutiques": "Boutiques Dior",
		"Too far": "Trop de résultats, veuillez affiner votre recherche en choisissant une plus petite zone de recherche.",
		"No result": "Aucune boutique disponible",
		"Other shops": "Autres boutiques",
		"Results": "Résultats de recherche",
		"Fewer results, zoom in": "Moins de résultats, zoomer",
		"More results, zoom out": "Plus de résultats, dézoomer",
		"Fewer results": "Moins de résultats",
		"More results": "Plus de résultats"
	},
	"SearchBlock": {
		"Geolocation": "Utiliser la géolocalisation pour trouver une boutique près de chez vous",
		"Search": "Rechercher"
	},
	"Share": {
		"Conditions": "En cliquant sur “Confirmer“, vous attestez avoir pris connaissance de la politique de confidentialité et consentez au traitement de vos données personnelles par %(brand)s dans les conditions énoncées dans la présente afin de répondre à votre demande. En cochant la case appropriée, vous consentez également au traitement de vos données personnelles par Christian Dior Couture à des fins de marketing direct, lequel peut être adapté en fonction de vos préférences et des informations que nous possédons à votre sujet.",
		"Recipient": "Votre destinataire",
		"Share Confirmation": "La fiche de votre boutique à bien été envoyée",
		"Share this shop": "Partager la fiche boutique",
		"Your favorite shop": "Votre boutique préférée"
	},
	"ShopBlock": {
		"Closed": "Fermée",
		"Closed today": "Fermée aujourd'hui",
		"Directions": "Itinéraire",
		"DirectionsAria": "Se rendre à %(shopName)s",
		"Make an appointment": "Prendre un rendez-vous",
		"Open": "Ouvert",
		"Opening time": "Horaires d'ouverture",
		"OpeningAria": "Plus d’informations sur les horaires d'ouverture",
		"ResultNumber": "Résultat numéro %(number)s",
		"Services": "Services",
		"ServicesAria": "Plus d'informations sur les services",
		"Share": "Partager",
		"Special hours": "Horaires spéciaux",
		"Today until %(hour)s": "Aujourd'hui jusqu'à %(hour)s",
		"Universes": "Univers",
		"UniversesAria": "Plus d’informations sur les collections similaires",
		"and": "et",
		"from": "de",
		"publicHolidays": "la boutique est probablement fermée",
		"to": "à"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/fr_be/translations.json
// module id = 864
// module chunks = 0